import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * The old sign-in path.
 *
 * This was one of three redirects in `next.config.ts`. The other two —
 * `/qr/:alias` and `/widget/*` — point at OTHER hosts and so have to stay at
 * the CDN edge (see the CloudFront function in `sst.config.ts`). This one is
 * same-origin, so it belongs here instead: it then works in `vite dev` and
 * `vite preview` too, rather than only once deployed behind CloudFront.
 */
export const Route = createFileRoute('/sign-in')({
  beforeLoad: () => {
    throw redirect({ to: '/login' })
  },
})
